// extracted by css-extract-rspack-plugin
export default {"cls1":"UserSentimentPopup-cls1_jl1","cls2":"UserSentimentPopup-cls2_n9E UserSentimentPopup-cls1_jl1"};